import script from "./MonitorCavaionPianificazioni.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonitorCavaionPianificazioni.vue?vue&type=script&setup=true&lang=ts"

import "./MonitorCavaionPianificazioni.vue?vue&type=style&index=0&id=97e7c258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97e7c258"]])

export default __exports__